import React from 'react'
import qaCallout from './qa-callout'

const doc = {
  title: 'Q&A: 3x36 (1/3) Staggered Running Bond Hatch Pattern',
  slug: 'qa-staggered-running-bond-hatch-pattern',
  tags: ['forum', 'q&a', 'question', 'answer'],
  category: 'q-and-a',
  content: (props) => {
    return <div>
      {qaCallout}
      <p>
        <a href="https://forums.autodesk.com/t5/revit-architecture-forum/3x36-1-3-staggered-running-bond-hatch-pattern/m-p/9155537#M260956" target="_blank" rel="noreferrer">Read more of this thread on forums.autodesk.com</a>
      </p>
      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title">Asked by <a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/5405552" target="_blank" rel="noreferrer">@dmoconnor</a> on 11/19/2019 on the Revit Architecture Forum:</strong><br/>
        Does anyone have a 3x36 one third staggered running bond hatch pattern?
      </blockquote>
      
      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 7/19/2020:</strong><br/>
        Easy Peasy Banana Squeezy 😎🎂
        <br/><br/>
        Assumed Revit and Model and Inches. <a href="https://pattycake.io/official/pat/Yl9VKB6VqgG">https://pattycake.io/official/pat/Yl9VKB6VqgG</a>
        <img src="/img/forum_content/3x361_3RunningBond.png" style={{maxWidth: '100%'}}/>
      </blockquote> 

    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/qa-staggered-running-bond-hatch-pattern.js